<template>
  <form class="form" @submit.stop.prevent="onSubmit">
    <div class="form-group">
      <label for="">Email <span class="text-danger">*</span></label>
      <input
        type="text"
        name=""
        class="form-control"
        id=""
        v-model="email"
        :class="errors['email'] ? 'border border-danger' : ''"
      />
      <span v-if="errors['email']" class="text-danger">{{
        errors["email"][0]
      }}</span>
    </div>
    <div class="form-group">
      <label for="">LSID <span class="text-danger">*</span></label>
      <input
        type="text"
        name=""
        class="form-control"
        id=""
        v-model="lsid"
        :class="errors['lsid'] ? 'border border-danger' : ''"
      />
      <span v-if="errors['lsid']" class="text-danger">{{
        errors["lsid"][0]
      }}</span>
    </div>
    <div class="form-group">
      <label for="">Check Url <span class="text-danger">*</span></label>
      <input
        type="text"
        name=""
        class="form-control"
        id=""
        v-model="check_url"
        :class="errors['check_url'] ? 'border border-danger' : ''"
      />
      <span v-if="errors['check_url']" class="text-danger">{{
        errors["check_url"][0]
      }}</span>
    </div>

    <hr />
    <!-- 
      <h4 @click="checkTwilioKey()">Checkme</h4> -->
    <button
      class="btn btn-success"
      ref="kt_fdle_config_submit"
      style="float:right"
    >
      Submit
    </button>
  </form>
</template>

<script>
import {
  FETCH_FDLE_CONFIG,
  SUBMIT_FDLE_CONFIG
} from "@/core/services/store/actions.type";
export default {
  data() {
    return {
      email: "",
      lsid: "",
      check_url: "",
      errors: [],
      id: 0
    };
  },
  created() {
    this.$store.dispatch(FETCH_FDLE_CONFIG).then(data => {
      var data_ = data.data;
      this.email = data_.email ? data_.email : "";
      this.lsid = data_.lsid ? data_.lsid : "";
      this.check_url = data_.check_url ? data_.check_url : "";
      this.id = data_.id ? data_.id : 0;
    });
  },

  methods: {
    // checkTwilioKey() {
    //   const client = require("twilio")(this.account_sid, this.auth_token);
    //   client.newKeys.create({friendlyName: 'User Joey'})
    //           .then(new_key => console.log(new_key.sid));
    // },
    onSubmit() {
      this.errors = [];
      const submitButton = this.$refs["kt_fdle_config_submit"];
      submitButton.disabled = true;
      submitButton.classList.add("spinner", "spinner-light", "spinner-right");
      var data = {
        email: this.email,
        lsid: this.lsid,
        id_: this.id,
        check_url: this.check_url
      };

      this.$store
        .dispatch(SUBMIT_FDLE_CONFIG, data)
        .then(data => {
          submitButton.classList.remove(
            "spinner",
            "spinner-light",
            "spinner-right"
          );
          submitButton.disabled = false;
          this.$toastr.s(data.msg);
        })
        .catch(err => {
          this.errors = err.msg;
          submitButton.classList.remove(
            "spinner",
            "spinner-light",
            "spinner-right"
          );
          submitButton.disabled = false;
          // this.$toastr.e(err.msg);
        });
    }
  }
};
</script>
